import Vue from 'vue'
import Vuex from 'vuex'

// 모든 모듈 modules로 임포트
import * as modules from './modules/'

// 공통 API 및 유틸
import http from '@/api'
import regExp from '@/common/regExp'

Vue.use(Vuex)

// 로컬스토리지에서 사용자 정보 가져오기 (없으면 null 반환)
function getUserDataFromLocalStorage () {
  const userData = localStorage.getItem('userData')
  return userData ? JSON.parse(userData) : null
}

const store = new Vuex.Store({
  state: {
    // 로그인 여부
    login: false,
    // 회원가입 진행 여부
    signUp: false,
    // 사용자 정보 (localStorage에서 초기화, 없으면 기본값)
    user: getUserDataFromLocalStorage() || {
      name: '',
      point: 0,
      userTotalPayment: 0,
      id: ''
    },
    // 경기 데이터
    gameData: {
      totalRate: 0,
      totalPayment: 0
    },
    // 기준 연도/전년도 (통계나 기록 조회용)
    thisYear: '',
    lastYear: ''
  },

  mutations: {
    // 로그인 여부 설정
    // 최초 로그인 시 사용자 정보/게임 데이터 불러오기
    login (state, isLogin) {
      state.login = isLogin
      if (state.login === true) {
        store.dispatch('getUserInfo')
        store.dispatch('getUserGameData')
      }
    },

    // 회원가입 여부 설정
    signUp (state, isSignUp) {
      state.signUp = isSignUp
    },

    // 사용자 정보 갱신 + 포맷팅 + 로컬 캐시 저장
    userInfo (state, payload) {
      state.user.name = payload.name
      state.user.point = regExp.comma(payload.point)
      state.user.userTotalPayment = regExp.comma(payload.userTotalPayment)
      state.user.id = payload.id
      localStorage.setItem('userData', JSON.stringify(state.user))
    },

    // 게임 데이터 갱신 + 포맷팅 + 로컬 캐시 저장
    userGameData (state, payload) {
      state.gameData.totalRate = payload.totalRate
      state.gameData.totalPayment = regExp.comma(payload.totalPayment)
      localStorage.setItem('userGameData', JSON.stringify(state.gameData))
    },

    // 기준 연도 설정 (전년도 자동 계산)
    setThisYear (state, year) {
      state.thisYear = year
      state.lastYear = Number(year) - 1
    }
  },

  actions: {
    // 사용자 정보 가져오기 -> userInfo 커밋
    async getUserInfo ({commit}) {
      if (localStorage.getItem('token')) {
        const user = await http.get('/user')
        commit('userInfo', {
          name: user.data.data.user_name,
          point: user.data.data.point,
          userTotalPayment: user.data.data.total_payment_amount,
          id: user.data.data.user_id
        })
        // 로컬 저장소에서 최신 값 확인 (검증용)
        getUserDataFromLocalStorage()
      }
    },

    // 경기 데이터 가져오기 -> userGameData 커밋
    async getUserGameData ({commit}) {
      if (localStorage.getItem('token')) {
        const data = await http.get('/ticket/game')
        commit('userGameData', {
          totalRate: data.data.total.total_rate,
          totalPayment: data.data.total_payment_amount
        })
      }
    }
  },

  getters: {
    // 로그인 여부 반환
    isLogin: state => state.login,
    // 회원가입 여부 반환
    isSignUp: state => state.signUp
  },

  // 외부 모듈 병합 (예: survey.js 등)
  modules: modules.default
})

export default store
